import Vue from 'vue';
import Vuex from 'vuex';

import alert from './modules/alert';
import auth from './modules/auth';
import user from './modules/user';
import loading from './modules/loading';
import application from './modules/application';
import reference from './modules/reference';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
		alert,
    	auth,
        user,
        loading,
        application,
        reference
    }
});
